import { AreaSlugMap } from '~/constants'
import { useGetLpisAndPercentilesQuery } from '~/graphql/generated/schema'
import { getAreaSlugList } from '~/utils/areaSlugUtils'

const MaxLpi = 2000
const AreaSlugList = getAreaSlugList('stats-page')

type AreaProps = {
  areaSlug: AreaSlugType
  notIncludedInLPI: boolean
  progress: number
  lpi: number
  lpiText: string
}

export const useLpiSummary = () => {
  const { loading, error, data } = useGetLpisAndPercentilesQuery()
  const lpiSummary = data?.me?.lpiSummary

  const overallLpi = lpiSummary?.overallLpi || 0
  const overallLpiText = overallLpi.toFixed(0)
  const overallPercent = (overallLpi / MaxLpi) * 100 // do not round this, as 1714(overall) and 1728(best) are the same 86%

  let hasAreaWithNoLpi = false

  const lpiByArea: AreaProps[] = []

  lpiSummary?.lpisByArea?.forEach?.((areaData) => {
    const matchedArea = AreaSlugList.find((areaSlug) => areaSlug === areaData.areaSlug)
    if (!matchedArea) return null

    const notIncludedInLPI = matchedArea === AreaSlugMap.math.code
    const lpi = areaData.lpi || 0
    const progress = Math.round((lpi / MaxLpi) * 100)

    if (lpi === 0 && !notIncludedInLPI) {
      // don't consider math area for overall lpi
      hasAreaWithNoLpi = true
    }

    lpiByArea.push({
      areaSlug: matchedArea,
      notIncludedInLPI,
      progress,
      lpi,
      lpiText: lpi.toFixed(0),
    })
  })

  return {
    loading,
    error,
    overallLpi,
    overallLpiText,
    overallPercent,
    hasAreaWithNoLpi,
    lpiByArea,
  }
}
